<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="title"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="480px"
    append-to-body
  >
    <section>
      <section class="tablePage">
        <section v-for="(item, index) in tableTemplateList" :key="index">
          <section class="template-title">
            <el-radio :label="item" v-model="template">{{
              item.templateName
            }}</el-radio>
            <span class="primary cur" @click="delTemplate(item.tId)">删除</span>
          </section>
          <section class="tableBox show-table-border">
            <el-table v-loading="tableData.loading" :data="item.fieldList">
              <el-table-column
                v-for="(item, index, key) in tableData.title"
                :key="key"
                :prop="item.prop"
                :label="item.label"
                align="center"
              />
            </el-table>
          </section>
        </section>
      </section>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading"
        >确 定</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
import {
  queryUserSalaryTemplate,
  deleteUserSalaryTemplate,
} from 'api/archives';
import {
  getUserInfo,
} from '@qx/utils/auth';
export default {
  data () {
    return {
      template: null,
      tableTemplateList: [],
      title: '',
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {
            prop: 'startNum',
            label: '开始里程（KM）',
          },
          {
            prop: 'endNum',
            label: '结束里程（KM）',
          },
          {
            prop: 'price',
            label: '里程单价（元/KM）',
          },
        ],
        data: [ // 表格内容
        ],
      },
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      salaryPattern: '',
      salaryPatternName: '',
      merLoading: false, // 商户选项loading中
      originData: {},
    };
  },
  methods: {

    /**
     * @param {Object} item 原有的项
     * @param {String} salaryPattern 工资类型
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item, salaryPattern) {
      this.template = null;
      let salaryPatternName = '';
      let tableDataTitle = [];
      if (salaryPattern === '2') {
        salaryPatternName = '里程';
        tableDataTitle = [
          { prop: 'startNum', label: '开始里程（KM）' },
          { prop: 'endNum', label: '结束里程（KM）' },
          { prop: 'price', label: '里程单价（元/KM）' },
        ];
      } else if (salaryPattern === '3') {
        salaryPatternName = '按趟';
        tableDataTitle = [
          { prop: 'startNum', label: '开始趟数' },
          { prop: 'endNum', label: '结束趟数' },
          { prop: 'price', label: '按趟单价(元/趟)' },
        ];
      }
      this.tableData.title = tableDataTitle;
      this.salaryPattern = salaryPattern;
      this.salaryPatternName = salaryPatternName;
      this.title = salaryPatternName + '工资选择模板';
      this.originData = item;
      this.dialogFormVisible = true;
      this.$refs.customForm && this.$refs.customForm.reset();
      this.getList();
    },

    async getList () {
      const userInfo = getUserInfo();
      const res = await queryUserSalaryTemplate({
        userId: userInfo.staffTFInfo.userId,
        tenantId: userInfo.staffTFInfo.tenantId,
        salaryPattern: this.salaryPattern,
      });
      if (!res.failed) {
        if (res.items && res.items.length) {
          this.tableTemplateList = res.items;
          console.log(this.tableTemplateList);
        }
      }
    },

    async delTemplate (tId) {
      const confirmRes = await this.$confirm('确定删除该模板吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        const resDel = await deleteUserSalaryTemplate({ tId });
        if (!resDel.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.getList();
          if (this.template) {
            if (tId === this.template.tId) {
              this.template = null;
            }
          }
        }
      }
    },

    async customFormPost () {
      if (!this.template) {
        this.$message({
          type: 'warning',
          message: '请选择工资模板',
        });
        return;
      }
      const confirmRes = await this.$confirm(`确定使用模板【${this.template.templateName}】覆盖当前已填写的${this.salaryPatternName}工资内容吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消操作
      });
      if (confirmRes === 'confirm') {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$emit('sub', this.template);
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.dialogFormVisible = false; // 关闭弹窗
      this.$emit('sub');
    },
  },
};
</script>

<style scoped lang="scss">
.template-title {
  margin-top: 16px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  &:first-child {
    margin-top: 0;
  }
}
</style>

